import React, { useState } from 'react';
import { createSubscription } from '../services/subscriptionService';

interface SubscribeButtonProps {
    className?: string;
    variant?: 'primary' | 'large';
}

/**
 * Subscribe button component that redirects to Stripe Checkout
 * Shows a simple button with loading state during subscription creation
 */
export const SubscribeButton: React.FC<SubscribeButtonProps> = ({
    className = '',
    variant = 'primary'
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSubscribe = async () => {
        try {
            setIsLoading(true);
            setError(null);

            const { url } = await createSubscription();

            // Redirect to Stripe Checkout
            window.location.href = url;
        } catch (err: any) {
            console.error('Failed to create subscription:', err);
            setError(err.message || 'Failed to start subscription process');
            setIsLoading(false);
        }
    };

    const baseClasses = "inline-flex items-center justify-center font-medium rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";

    const variantClasses = variant === 'large'
        ? "px-8 py-4 text-lg bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500"
        : "px-6 py-2 text-base bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500";

    return (
        <div className="flex flex-col items-center space-y-2">
            <button
                onClick={handleSubscribe}
                disabled={isLoading}
                className={`${baseClasses} ${variantClasses} ${className}`}
            >
                {isLoading ? (
                    <>
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Loading...
                    </>
                ) : (
                    'Subscribe for $4.99/week'
                )}
            </button>

            {error && (
                <p className="text-red-600 text-sm text-center max-w-sm">
                    {error}
                </p>
            )}
        </div>
    );
};